'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

var _propTypes3 = require('utils/prop-types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = require('./SimpleTabContent.scss');

var SimpleTabContent = (_temp = _class = function (_PureComponent) {
  (0, _inherits3.default)(SimpleTabContent, _PureComponent);

  function SimpleTabContent() {
    (0, _classCallCheck3.default)(this, SimpleTabContent);
    return (0, _possibleConstructorReturn3.default)(this, (SimpleTabContent.__proto__ || (0, _getPrototypeOf2.default)(SimpleTabContent)).apply(this, arguments));
  }

  (0, _createClass3.default)(SimpleTabContent, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          children = _props.children;


      return _react2.default.createElement(
        'div',
        { className: (0, _bind2.default)(styles.content, className) },
        children
      );
    }
  }]);
  return SimpleTabContent;
}(_react.PureComponent), _class.propTypes = {
  children: _propTypes3.nodes,
  className: _propTypes2.default.string
}, _temp);
exports.default = SimpleTabContent;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/SimpleTabContent/SimpleTabContent.js
// module id = 846
// module chunks = 1